// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputCheckbox,
  InputNumber,
} from '@vroskus/library-components';

// Types
type $Props = $Translate & {
  item: $Model<'RegattaPaymentDiscount'> | $ModelUpsertParams<'RegattaPaymentDiscount'>;
};

const RegattaPaymentDiscountFieldsView = function ({
  item,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col sm={6}>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
        <Col sm={3}>
          <InputNumber
            label={`${t('Value')} (${t('Cents')})`}
            min={0}
            name={'Value'}
            required
            value={item.Value}
          />
        </Col>
        <Col sm={3}>
          <div className={'align-checkbox'}>
            <InputCheckbox
              label={t('Used')}
              name={'Used'}
              value={item.Used}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Description')}
            name={'Content'}
            value={item.Content}
          />
        </Col>
      </Row>
    </>
  );
};

export default RegattaPaymentDiscountFieldsView;
